module.exports = __webpack_public_path__ + "static/img/qpGame1.3121d21.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/qpGame1.png
// module id = FLZe
// module chunks = 3